import React from "react"

export default function Preloader() {
    return (
        <div className='preloader flex'>
            <div className='ma'>
            </div>
        </div>
    )
}
